import type { ReactElement } from 'react';
import type { TabProps } from './types';

export const resolveActiveTabId = <T extends string>(
  activeTabId: T,
  children: ReactElement<TabProps<T>>[]
): T =>
  children.some(child => child.props.tabId === activeTabId)
    ? activeTabId
    : children[0].props.tabId;
